import { Phone } from "lucide-react";
import { formatPhone } from "@/lib/phone";

export const telHref = (p) => `tel:${String(p || "").replace(/[^\d+]/g, "")}`;

export const Tel = ({ phone, className = "", icon = true, testId }) => {
  if (!phone) return null;
  return <a href={telHref(phone)} data-testid={testId || "tel-link"} onClick={(e) => e.stopPropagation()} className={`inline-flex items-center gap-1 text-primary hover:underline ${className}`} title="Click to call">{icon && <Phone className="w-3 h-3" />}{formatPhone(phone)}</a>;
};
